import API from './../api';
import {
    WEBSITE_CURRENT_ENDPOINT,
    WEBSITE_CURRENT_RESET_ENDPOINT,
    WEBSITE_CURRENT_LOGO_ENDPOINT,
    WEBSITE_PREVIEW_ENDPOINT,
} from '../endpoints';

export default {

    namespaced: true,

    state() {
        return {
            currentWebsite: null,
            websiteFormValues: null,
        };
    },

    getters: {
        currentWebsite: (state) => state.currentWebsite,
        websiteFormValues: (state) => state.websiteFormValues,
    },

    mutations: {
        gotCurrentWebsite(state, response) {
            state.currentWebsite = response.data;
        },
        updatedCurrentWebsite(state, response) {
            state.currentWebsite = response.data;
        },
        resetCurrentWebsite(state, response) {
            state.currentWebsite = response.data;
            if (state.websiteFormValues) {
                state.websiteFormValues.css_variables = response.data.css_variables;
            }
        },
        setWebsiteFormValues(state, values) {
            state.websiteFormValues = values;
        }
    },

    actions: {
        async fetchCurrentWebsite({ commit }) {
            commit('gotCurrentWebsite', await API.get(WEBSITE_CURRENT_ENDPOINT()));
        },
        async updateCurrentWebsite({ commit }, payload) {
            commit(
                'updatedCurrentWebsite',
                await API.patch(WEBSITE_CURRENT_ENDPOINT(), payload)
            );
        },
        async uploadLogoForCurrentWebsite({ commit }, payload) {
            const data = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                if (value) {
                    data.append(key, value);
                }
            })

            commit(
                'updatedCurrentWebsite',
                await API.post(WEBSITE_CURRENT_LOGO_ENDPOINT(), data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            );
        },
        async deleteLogoForCurrentWebsite({ commit }) {
            commit(
                'updatedCurrentWebsite',
                await API.delete(WEBSITE_CURRENT_LOGO_ENDPOINT())
            );
        },
        async resetCurrentWebsite({ commit }) {
            commit(
                'resetCurrentWebsite',
                await API.post(WEBSITE_CURRENT_RESET_ENDPOINT())
            );
        },
        async updatePreview(_, payload) {
            await API.put(WEBSITE_PREVIEW_ENDPOINT(), payload);
        },
    },

};
